import {Migrations} from '~/modules/api';

const recordIdsPlaceholder = `Enter dato record IDs separated by newlines or commas
Example:
12345
67890
11111,22222,33333`;

type MigrationTypeConfig = {
  label: string;
  params: Record<
    string,
    {
      label: string;
      type: string;
      required: boolean;
      placeholder?: string;
      defaultValue?: any;
      validate: (value: string) => {
        isValid: boolean;
        error?: string;
        parsed?: any;
        helperText?: string;
      };
    }
  >;
};

const recordIdsConfigParams: MigrationTypeConfig['params'] = {
  recordIds: {
    label: 'Record IDs',
    type: 'textarea',
    required: false,
    placeholder: recordIdsPlaceholder,
    defaultValue: '',
    validate: (input: string) => {
      if (!input.trim()) return {isValid: true, error: '', parsed: undefined};
      const ids = input
        .split(/[\n,]/)
        .map(id => id.trim())
        .filter(id => id.length > 0);
      if (ids.length === 0) {
        return {
          isValid: false,
          error: 'Please enter at least one record ID',
          parsed: undefined,
        };
      }
      const validIdPattern = /^[a-zA-Z0-9-_]+$/i;
      const invalidIds = ids.filter(id => !validIdPattern.test(id));
      if (invalidIds.length > 0) {
        return {
          isValid: false,
          error: `Record IDs cannot contain special characters`,
          parsed: undefined,
          helperText: '',
        };
      }
      return {
        isValid: true,
        error: '',
        parsed: ids,
        helperText: `${ids.length} record ID${ids.length > 1 ? 's' : ''} detected.`,
      };
    },
  },
};

export const datoReferencesMigrationConfigParams: MigrationTypeConfig['params'] = {
  ...recordIdsConfigParams,
  requireAccessedDate: {
    label: 'Require Accessed Date',
    type: 'checkbox',
    required: true,
    defaultValue: true,
    validate: (input: string) => {
      return {
        isValid: true,
        error: '',
        parsed: input === 'true',
        helperText: '',
      };
    },
  },
};

export const migrationTypeRegistry: Record<
  Migrations.MigrationName,
  MigrationTypeConfig
> = {
  migrateDatoReferencesToCollection: {
    label: 'Migrate Question References to Collection',
    params: datoReferencesMigrationConfigParams,
  },
  migrateArticleReferencesToCollection: {
    label: 'Migrate Article References to Collection',
    params: datoReferencesMigrationConfigParams,
  },
  migrateParentArticleReferencesToCollection: {
    label: 'Migrate Parent Article References to Collection',
    params: datoReferencesMigrationConfigParams,
  },
  migrateQuestionWorkflowStageReviewed: {
    label: 'Migrate Question Workflow Stage Reviewed',
    params: { ...recordIdsConfigParams },
  },
  migrateAskLunaRatings: {
    label: 'Migrate Ask Luna Ratings',
    params: {...recordIdsConfigParams},
  },
};
